'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VXPagination = undefined;

var _is = require('ramda/src/is');

var _is2 = _interopRequireDefault(_is);

var _path = require('ramda/src/path');

var _path2 = _interopRequireDefault(_path);

var _min = require('ramda/src/min');

var _min2 = _interopRequireDefault(_min);

var _times = require('ramda/src/times');

var _times2 = _interopRequireDefault(_times);

exports.getStyleOverrides = getStyleOverrides;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _core = require('@blueprintjs/core');

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginatorButton = (0, _glamorous2.default)(_core.Button)({}, getStyleOverrides('button'));

var VXPagination = exports.VXPagination = function VXPagination(props) {
  var onPageChange = props.onPageChange,
      hideOnSinglePage = props.hideOnSinglePage,
      currentPage = props.currentPage,
      _props$styleOverrides = props.styleOverrides,
      styleOverrides = _props$styleOverrides === undefined ? {} : _props$styleOverrides;

  var _getPaginationInfo = getPaginationInfo(props),
      isStart = _getPaginationInfo.isStart,
      isEnd = _getPaginationInfo.isEnd,
      isSinglePage = _getPaginationInfo.isSinglePage,
      totalPages = _getPaginationInfo.totalPages,
      pageOffset = _getPaginationInfo.pageOffset,
      pagesBuffered = _getPaginationInfo.pagesBuffered;

  if (isSinglePage && hideOnSinglePage) {
    return null;
  }

  return _react2.default.createElement(
    _glamorous.ThemeProvider,
    { theme: { paginator: styleOverrides } },
    _react2.default.createElement(
      _glamorous.Div,
      { className: _core.Classes.BUTTON_GROUP, css: getStyleOverrides('container') },
      _react2.default.createElement(PaginatorButton, {
        iconName: 'chevron-backward',
        onClick: function onClick(e) {
          return onPageChange(1);
        },
        disabled: isStart
      }),
      _react2.default.createElement(PaginatorButton, {
        iconName: 'chevron-left',
        onClick: function onClick(e) {
          return onPageChange(currentPage - 1);
        },
        disabled: isStart
      }),
      (0, _times2.default)(function (n) {
        var pageBuffered = n + pageOffset;
        return _react2.default.createElement(PaginatorButton, {
          key: pageBuffered,
          text: pageBuffered,
          onClick: function onClick(e) {
            return pageBuffered === currentPage ? null : onPageChange(pageBuffered);
          },
          active: pageBuffered === currentPage
        });
      })(pagesBuffered),
      _react2.default.createElement(PaginatorButton, {
        iconName: 'chevron-right',
        onClick: function onClick(e) {
          return onPageChange(currentPage + 1);
        },
        disabled: isEnd
      }),
      _react2.default.createElement(PaginatorButton, {
        iconName: 'chevron-forward',
        onClick: function onClick(e) {
          return onPageChange(totalPages);
        },
        disabled: isEnd
      })
    )
  );
};

VXPagination.propTypes = {
  currentPage: _propTypes2.default.number.isRequired,
  pageSize: _propTypes2.default.number.isRequired,
  pageBuffer: _propTypes2.default.number.isRequired,
  totalItemsCount: _propTypes2.default.number.isRequired,
  onPageChange: _propTypes2.default.func.isRequired,
  hideOnSinglePage: _propTypes2.default.bool
};

VXPagination.defaultProps = {
  currentPage: 1,
  pageSize: 12,
  pageBuffer: 3,
  hideOnSinglePage: true
};

function getPaginationInfo(props) {
  var pageSize = props.pageSize,
      pageBuffer = props.pageBuffer,
      totalItemsCount = props.totalItemsCount,
      currentPage = props.currentPage;


  var totalPages = Math.ceil(totalItemsCount / pageSize);
  var pageSymmetry = pageBuffer * 2;

  var pageOffset = currentPage - pageBuffer > 1 ? (0, _min2.default)(currentPage - pageBuffer, totalPages - pageSymmetry) : 1;

  return {
    totalPages: totalPages,
    pageOffset: pageOffset,
    pagesBuffered: (0, _min2.default)(pageSymmetry + 1, totalPages),
    isStart: currentPage <= 1,
    isEnd: currentPage >= totalPages,
    isSinglePage: totalPages < 2
  };
}

function getStyleOverrides(name) {
  return function (props) {
    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    var overrides = (0, _path2.default)(['theme', 'paginator', name], props);
    if ((0, _is2.default)(Function, overrides)) {
      return overrides.apply(undefined, [props].concat(rest));
    }
    return overrides;
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/vx-pagination/index.js
// module id = 2037
// module chunks = 0